module.exports = __webpack_public_path__ + "img/kurikulum-merdeka.72a91d2f.png";